// English comment: Cloudprinter-style spine width calculation helpers.
export const PAPER_BULK = {
  MCG: 0.8,
  MCS: 0.9,
  ECB: 1.2,
  OFF: 1.22,
} as const;

export const COVER_THICKNESS = {
  hardcover_3mm: 3.0,
  hardcover_2mm: 2.0,
  perfect_binding_softcover: 0.5,
} as const;

export type PaperBulkType = keyof typeof PAPER_BULK;
export type CoverThicknessType = keyof typeof COVER_THICKNESS;

export function calculateSpineMm(args: {
  pageCount: number;
  paperWeightGsm: number;
  paperBulkType: PaperBulkType;
  coverThicknessType: CoverThicknessType;
  extraMm?: number;
}) {
  const bulk = PAPER_BULK[args.paperBulkType];
  const cover = COVER_THICKNESS[args.coverThicknessType];
  const extra = Number(args.extraMm ?? 0);
  const raw =
    (Number(args.paperWeightGsm) * bulk * (Number(args.pageCount) / 2)) / 1000 +
    2 * cover +
    extra;
  return Number(raw.toFixed(2));
}
